import { useRequiredContext } from "@redotech/react-util/context";
import { EffectApiClientContext } from "@redotech/redo-merchant-app-common/effect-api-client-provider";
import { useQuery } from "@tanstack/react-query";
import { Effect } from "effect";

export function useIntegrations(options?: { includeDeleted?: boolean }) {
  const effectApi = useRequiredContext(EffectApiClientContext);
  const includeDeleted = options?.includeDeleted ?? false;

  return useQuery({
    queryKey: ["integrations", includeDeleted],
    queryFn: async () => {
      const client = effectApi.getClient();

      const result = await effectApi.runPromise(
        client.integration
          .getTeamIntegrations({
            urlParams: {
              limit: 100,
              ...(includeDeleted ? { includeDeleted: true } : {}),
            },
          })
          .pipe(Effect.orDie),
      );

      return result.items;
    },
  });
}

export { type IntegrationWithChannelDataResponse } from "@redotech/effect-api-shared/models/shopper-ai/integration/integration";
